<!-- breadcrumb -->

<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Pendiente Analisis</h4><span class="text-muted mt-1 tx-13 ms-2 mb-0">/
    Inicio</span>
  </div>
</div>
</div>

<div class="row">
  <div class="col-md-12 col-xl-12 col-xs-12 col-sm-12">

    @if (spinnerBoolean) {
      <div class="text-center">
        <div class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <br>
        </div>
      }
      <!--div-->
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">

            <table  datatable [dtOptions]="dtOptions"  class="table table-bordered table-striped table-hover dt-ext">

              <thead>
                <tr>
                  <th>#</th>
                  <th>Factura</th>
                  <th>Nº Orden</th>
                  <th>Paciente</th>
                  <th>Celular Paciente</th>
                  <th>Fec. Nacimiento Paciente</th>
                  <th>Cod. Doctor</th>
                  <th>Doctor</th>
                  <th>Sucursal</th>
                  <th>Fecha de registro</th>
                  <th>Tipo</th>
                  <th>Responsable</th>
                  <th>Acciones</th>

                </tr>
              </thead>
              <tbody >

                @for (dt of ordenes; track rowIndex; let rowIndex = $index) {
                  <tr >
                    <td>{{dt.id}}</td>
                    <td>{{dt.factura}}</td>
                    <td><div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                    @if (ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !='') {
                      <div>
                        <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                      </div>
                    }
                  </td>
                  <td>{{ dt.nombre }}</td>
                  <td>{{ dt.telefono }} </td>
                  <td>@if (ordenes[rowIndex].FEC_CLI !== null) {
                    <div>
                      <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                    </div>
                  }
                  @if (ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null') {
                    <div>
                      <div class="text-center text-danger">NO ESTABLECIDO</div>
                    </div>
                  }</td>
                  <td>{{ dt.codigoDoctor }}</td>
                  <td>{{ dt.nombreDoctor }}</td>
                  <td>{{ dt.direccionSucursal }}</td>
                  <td>@if (ordenes[rowIndex].tipo === 'WEB') {
                    <div>
                      <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                    </div>
                  }
                  @if (ordenes[rowIndex].tipo === 'MOVIL') {
                    <div>
                      <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                    </div>
                  }
                </td>
                <td>{{dt.fechaOrden}}</td>
                <td>{{dt.responsable}}</td>
                <td>
                  <div ngbDropdown container="body">
                    <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                      <i class="fe fe-settings"></i>
                    </button>
                    <div class="tx-13" ngbDropdownMenu>
                      <div >
                        <a ngbDropdownItem href="javascript:;" (click)="subirImagenesAnalisis(ordenes[rowIndex].COD_ORD)">
                          <i class="far fa-file-image text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;AÑADIR IMÁGENES</b>
                        </a>
                      </div>
                      <div>
                        <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].nombreDoctor,ordenes[rowIndex].telefonoDoctor)">
                          <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR</b>
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>


        </table>
      </div>
    </div>
  </div>
</div>
</div>
